import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Text } from '@radix-ui/themes';
import { useAgentStatus } from '@/shared/use-agent-status';
import { AgentMessageLayout } from './agent-message-layout';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

const PulsingText = styled(Text)`
  animation: ${pulse} 2s ease-in-out infinite;
`;

export function AgentThinking() {
  const { statusLabel, isIdle } = useAgentStatus();

  if (isIdle) {
    return null;
  }

  return (
    <AgentMessageLayout animateIcon="lifecycle">
      <PulsingText size="1" color="gray">
        {statusLabel}
      </PulsingText>
    </AgentMessageLayout>
  );
}
